export default __webpack_public_path__ + "static/media/AddONGimg2.61f99c7b.png";